import React from "react";
import { Provider } from "react-redux";

import locationStore from "./redux/locationStore";
import { LocationsActions } from "./types";

export default class LocationContainer extends React.Component<any> {
  Component = null;
  locationStore = null;

  constructor(props: any) {
    super(props);
    const { component, ...payload } = props;
    this.Component = require(`./${component}`).default;
    this.locationStore = locationStore(props.prefix);
    this.locationStore.dispatch({
      type: LocationsActions.StoreInitialState,
      payload,
    });
  }

  render() {
    const { component, session, prefix, ...props } = this.props;
    const Component = this.Component;

    return (
      <Provider store={this.locationStore}>
        <Component {...props} />
      </Provider>
    );
  }
}
